import * as Yup from 'yup'
import validationConfig from 'custom/config/validation.config.json'
const accountConfig = validationConfig['openAccount']
import { VALIDATION_MESSAGES } from '../../utils/translation-constants'

const ValidateAccountNo = accountConfig['isAccountNoRequired']
  ? {
      accountNumber: Yup.string().required(VALIDATION_MESSAGES.FUNDING_ACC_NO),
    }
  : {
      accountNumber: Yup.string().optional(),
    }

const ValidateAccountClass = accountConfig['isAccountClassRequired']
  ? {
      accClassName: Yup.string().required(VALIDATION_MESSAGES.ACCOUNT_CLASS),
    }
  : {
      accClassName: Yup.string().optional(),
    }

export const AddAccountSchema = Yup.object().shape({
  ...ValidateAccountNo,
  ...ValidateAccountClass,
})
